import React, { ChangeEvent, FC, useMemo } from 'react';

import { format } from 'date-fns';
import { debounce } from 'lodash';

import { TRANSACTION_TYPE_MAP } from '../../../constants';
import Datepicker from '../../../modules/datepicker/datepicker/datepicker';
import UiSearchInput from '../../../modules/ui/ui-search-input/ui-search-input';
import UiSelect, { OptionType } from '../../../modules/ui/ui-select/ui-select';
import { DOCUMENTS_SEARCH_FILTERS } from '../../../types';

import './index.scss';

interface IFiltersProps {
  onChange: (data: Record<string, any>) => void;
  filters: DOCUMENTS_SEARCH_FILTERS;
}

const SEARCH_FILTER_PLACEHOLDER = 'Поиск, номер документа, названиие компании';
const DEBOUNCE_TIMEOUT = 500;

const OPTIONS: OptionType[] = [
  {
    value: '',
    label: 'Все документы',
  },
].concat(
  Object.keys(TRANSACTION_TYPE_MAP)
    .map((key, i) => ({
      value: key as string,
      label: Object.values(TRANSACTION_TYPE_MAP)[i] as string,
    }))
    .filter((o) => o.value !== 'CREDIT_REPAYMENT')
);

const Filters: FC<IFiltersProps> = ({ onChange, filters }) => {
  const initOperationTypes = useMemo(() => {
    if (filters?.operationTypes?.length)
      return OPTIONS.find(
        (o) =>
          o.value ===
          (filters?.operationTypes
            ? filters?.operationTypes.find((i) => i) || ''
            : '')
      );

    return OPTIONS[0];
  }, [filters?.operationTypes]);

  const onPeriodChange = ({ from, to }: Record<string, any>) => {
    onChange({
      period: {
        from: from ? format(new Date(from), 'yyyy-MM-dd') : null,
        to: to ? format(new Date(to), 'yyyy-MM-dd') : null,
      },
    });
  };

  const onDropdownFilterChange = (val: Record<string, any>) =>
    onChange({
      operationTypes: val.value ? [val.value] : null,
    });

  const onQueryChange = debounce((e: ChangeEvent<HTMLInputElement>) => {
    onChange({ search: e.target.value });
  }, DEBOUNCE_TIMEOUT);

  return (
    <div className="filters-documents">
      <UiSearchInput
        sm
        onChange={onQueryChange}
        placeholder={SEARCH_FILTER_PLACEHOLDER}
      />
      <Datepicker
        sm
        type="range"
        period={filters.period}
        onPeriodChange={(range) =>
          onPeriodChange({
            from: range.start?.toString() || '',
            to: range.end?.toString() || '',
          })
        }
      />
      <UiSelect
        value={initOperationTypes}
        options={OPTIONS}
        onChange={(val) =>
          val && !Array.isArray(val) && onDropdownFilterChange(val)
        }
        sm
      />
    </div>
  );
};

export default Filters;
